"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChatQueueImpl = void 0;
const sleep_1 = require("./sleep");
const KEY = "ChatQueueImpl.messageQueue";
class ChatQueueImpl {
    constructor(cache) {
        this.isLocked = false;
        this.messages = [];
        this.fetch = async (processor) => {
            await this.lock();
            if (this.messages.length !== 0) {
                try {
                    await processor(this.messages[0]);
                    this.messages = this.messages.slice(1);
                    await this.cache.setArray(KEY, this.messages).asPromise();
                }
                catch (e) {
                    await this.unlock();
                    throw e;
                }
            }
            await this.unlock();
            return this.messages.length > 0;
        };
        this.queue = async (message, timeZone, application, memberId) => {
            await this.lock();
            this.messages.push({
                message,
                memberId,
                timeZone: timeZone.toString(),
                application,
            });
            await this.cache.setArray(KEY, this.messages).asPromise();
            await this.unlock();
        };
        this.lock = async () => {
            while (this.isLocked) {
                await (0, sleep_1.sleep)(50);
            }
            this.isLocked = true;
        };
        this.unlock = async () => {
            this.isLocked = false;
        };
        this.fetchMessages = async () => {
            this.messages = (await this.cache
                .getArray(KEY)
                .withDefault([])
                .asPromise()).map((pendingMessage) => {
                var _a;
                return ({
                    ...pendingMessage,
                    application: (_a = pendingMessage.application) !== null && _a !== void 0 ? _a : "PBP",
                });
            });
        };
        this.getPending = async (application) => {
            await this.lock();
            const messages = JSON.parse(JSON.stringify(this.messages));
            await this.unlock();
            return messages.filter((m) => m.application == application);
        };
        this.cache = cache;
        this.lock().then(this.fetchMessages).then(this.unlock);
    }
}
exports.ChatQueueImpl = ChatQueueImpl;
//# sourceMappingURL=ChatQueue.js.map